// Creative Studio templates — two endpoint families with identical
// shapes. Org-scoped lives at /orgs/creative_studio_templates;
// workspace-scoped at the flat /creative_studio_templates path
// (workspace resolved from the WorkspaceID header, same as /media).
// List uses opaque cursor pagination; show / create / update return
// the full snapshot with image src URLs re-signed at read time.

const BASE = "/orgs/creative_studio_templates";
const WORKSPACE_BASE = "/creative_studio_templates";

export const createListCreativeStudioTemplatesRequest = ({ cursor, limit = 20 } = {}) => ({
  url: BASE,
  method: "GET",
  params: {
    ...(cursor ? { cursor } : {}),
    limit,
  },
});

export const createGetCreativeStudioTemplateRequest = (id) => ({
  url: `${BASE}/${id}`,
  method: "GET",
});

export const createCreateCreativeStudioTemplateRequest = (data) => ({
  url: BASE,
  method: "POST",
  data,
});

export const createUpdateCreativeStudioTemplateRequest = (id, data) => ({
  url: `${BASE}/${id}`,
  method: "PUT",
  data,
});

export const createDeleteCreativeStudioTemplateRequest = (id) => ({
  url: `${BASE}/${id}`,
  method: "DELETE",
});

export const createWorkspaceListCreativeStudioTemplatesRequest = ({
  cursor,
  limit = 20,
} = {}) => ({
  url: WORKSPACE_BASE,
  method: "GET",
  params: {
    ...(cursor ? { cursor } : {}),
    limit,
  },
});

export const createWorkspaceGetCreativeStudioTemplateRequest = (id) => ({
  url: `${WORKSPACE_BASE}/${id}`,
  method: "GET",
});

export const createWorkspaceCreateCreativeStudioTemplateRequest = (data) => ({
  url: WORKSPACE_BASE,
  method: "POST",
  data,
});

export const createWorkspaceUpdateCreativeStudioTemplateRequest = (id, data) => ({
  url: `${WORKSPACE_BASE}/${id}`,
  method: "PUT",
  data,
});

export const createWorkspaceDeleteCreativeStudioTemplateRequest = (id) => ({
  url: `${WORKSPACE_BASE}/${id}`,
  method: "DELETE",
});
